<div
  [ngClass]="
    currentStep === submitPage ? 'action-buttons-user' : 'action-buttons'
  "
>
  <div
    *ngIf="
      (backPages | arrayIncludes: currentStep) ||
      (currentStep !== 'WELCOME' && currentStep !== 'THANK_YOU')
    "
    class="back-button"
  >
    <markant-icon-button
      icon="m_arrow-left"
      colorScheme="primary"
      (click)="previousPage()"
    ></markant-icon-button>
    <markant-button
      type="button"
      colorScheme="primary"
      variant="clear"
      (click)="previousPage()"
    >
      <span>{{ 'general.back' | transloco }}</span>
    </markant-button>
  </div>

  <markant-button
    *ngIf="!(['THANK_YOU', submitPage, 'WELCOME'] | arrayIncludes: currentStep)"
    class="next-button"
    colorScheme="primary"
    (click)="nextPage()"
  >
    {{ 'common.next' | transloco }}
  </markant-button>
  <markant-button
    *ngIf="currentStep === 'WELCOME'"
    class="start-button"
    colorScheme="primary"
    (click)="nextPage()"
    >{{ 'register.start' | transloco }}
  </markant-button>
  <markant-button
    *ngIf="currentStep === submitPage"
    class="next-button"
    colorScheme="primary"
    [loading]="submitIsLoading"
    (click)="submit()"
    >{{ submitButtonText | transloco }}
  </markant-button>
  <markant-button
    *ngIf="closePages | arrayIncludes: currentStep"
    class="start-button"
    colorScheme="primary"
    (click)="back()"
    >{{ 'common.close' | transloco }}
  </markant-button>
</div>
